export type FlowVersionEntry = {
  flow_version_id: string;
  name: string | null;
  decisions_30d: number;
};

export type SchemaKeyEntry = {
  key: string;
  /** Absent when the key surfaced only in the value sample. */
  decisions?: number;
  /** Present only for enum-like keys; absent means high-cardinality. */
  values?: { value: string; decisions: number }[];
  /** Above `values.length` when the list is a top-N. */
  distinct_values?: number;
};

export type WorkspaceSchema = {
  decisions_last_7d: number;
  sampled_decisions: number;
  strings: SchemaKeyEntry[];
  numerics: SchemaKeyEntry[];
  /** Why the snapshot is missing, when the preflight failed. */
  unavailable?: string;
};

export type LiveAnalyticsAgentContext = {
  flow_id: string;
  flow_name: string;
  flow_versions: FlowVersionEntry[];
  workspace_schema: WorkspaceSchema;
};

type LiveAnalyticsAgentContextInputs = {
  flowId: string;
  flowName: string;
  workspaceSchema: WorkspaceSchema;
  flowVersions: FlowVersionEntry[];
};

/** The per-conversation context, delivered as `structured_input` on the first
 * message of a session. Values only — how to read them is in the prompt. */
export const buildLiveAnalyticsAgentContext = ({
  flowId,
  flowName,
  workspaceSchema,
  flowVersions,
}: LiveAnalyticsAgentContextInputs): LiveAnalyticsAgentContext => ({
  flow_id: flowId,
  flow_name: flowName,
  flow_versions: flowVersions,
  workspace_schema: workspaceSchema,
});
